import type { SocketColumnUpdate } from "../../providers/SocketContext";

/**
 * The newest socket update for one cell. The socket store keeps every update in arrival order, so
 * the last one is the cell's state now: a `failed` sent after the enqueue's `active` ends the
 * cell's run (PREC-4836), where the first one would keep it "Processing" for good.
 */
export const latestCellUpdate = (
	updates: SocketColumnUpdate[],
	listPersonId: number | undefined,
	customColumnId: number | undefined
): SocketColumnUpdate | undefined =>
	updates
		.filter(
			(update) => update.listPersonId === listPersonId && update.customColumnId === customColumnId
		)
		.at(-1);

/**
 * Whether the cell shows "Processing": it has no value, and the newest word on it says it runs.
 * A socket update is newer than the fetched row, so its status wins over the row's pending event:
 * an event that failed after the page loaded is still in the row until the next fetch.
 */
export const isCellProcessing = ({
	hasValue,
	update,
	hasPendingEvent,
}: {
	hasValue: boolean;
	update: SocketColumnUpdate | undefined;
	hasPendingEvent: boolean;
}): boolean => !hasValue && (update ? update.status === "active" : hasPendingEvent);
